export default {
  actionButtons: {
    margin: "35px 0",
    display: "flex",
    columnGap: "40px"
  },

  iconLabelContainer: {
    columnGap: "6px",
    cursor: "pointer"
  },
  pointer: {
    cursor: "pointer"
  },
  stateRow: {
    display: "flex",
    columnGap: "20px",
    alignItems: "end",
  },
  flexColumn: {
    display: 'flex', 
    flexDirection: 'column'
  },
  selfAlignEnd: { 
    alignSelf: 'end'
  },
  addAddressCheckboxDiv: {
    display: 'flex', 
    gap: '10px', 
    alignItems: 'center'
  }
}